import TOS from "views/TOSView";

export default function Page() {
  return (
    <>
      <TOS />
    </>
  );
}
